<i18n src="./resources/locales.json"></i18n>

<template>
  <div>
    <v-alert class="offline-mode-indicator warning--text" dark :value="isOfflineModeEnabled">
      {{ $t('offlineMode') }}
    </v-alert>

    <v-app-bar
      id="app-toolbar"
      class="toolbar dark"
      :class="{ secondary: $vuetify.theme.dark, primary: !$vuetify.theme.dark }"
      :offline="isOfflineModeEnabled"
      height="64"
      app
      fixed
      clipped-left
    >
      <div aria-label="Brand logo">
        <v-img
          id="img-logo"
          :src="require('@/assets/xtiumcolor_x_mark.svg')"
          max-height="36"
          max-width="36"
          :dark="$vuetify.theme.dark"
        />
      </div>
      <span style="display:inline-block; width: 30px;"></span>
      {{ date }}
      <span style="display:inline-block; width: 30px;"></span>
      {{ time }}
      <v-spacer></v-spacer>
      <span style="font-size: 1.2em;">{{ getWallboardName }}</span>
      <v-spacer></v-spacer>

      <!-- Agent Info & Image Profile -->

      <v-btn role="button" :aria-label="$t('buttons.signout')" color="primary" @click="logout">
        <span v-once>{{ $t('buttons.signout') }}</span>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'EcsAppHeader',

  data() {
    return {
      socketReconnectionAttemptCounter: 0,
      currentTimeInterval: null,
      currentTime: 0
    };
  },

  computed: {
    ...mapGetters('SETTINGS', ['isOfflineModeEnabled']),
    ...mapGetters('WALLBOARD', ['getWallboardName']),

    time() {
      return moment(this.currentTime).format('h:mm a');
    },

    date() {
      return moment().format('MMMM D YYYY');
    }
  },

  sockets: {
    reconnect() {
      this.socketReconnectionAttemptCounter = 0;
    },

    reconnecting() {
      this.socketReconnectionAttemptCounter++;
    }
  },
  mounted() {
    this.currentTimeInterval = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  },

  beforeDestroy() {
    clearInterval(this.currentTimeInterval);
  },

  methods: {
    logout() {
      this.$emit('user-logout-request');
    }
  }
};
</script>
<style scoped>
#app-toolbar {
  box-shadow: none;
}

.toolbar {
  z-index: 119;
  margin-top: 0 !important;
}

[offline].toolbar {
  margin-top: 30px !important;
}

#img-logo.theme--light {
  filter: saturate(0) brightness(5);
}

#agent_info {
  cursor: pointer;
  padding-left: 8px;
}

.offline-mode-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30px;
  color: #f89e7e;
  font-size: 12px;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
  border-radius: 0;
}

.offline-mode-indicator.v-icon {
  font-size: 16px;
}

[class='~dark'].v-btn.active:before {
  color: var(--v-primary-base);
  opacity: 0;
}

.v-btn.active:before {
  opacity: 0.25;
}
</style>
